/**
 * Created by mateimisarca on 05/12/2019
 */

import ResetPassword from './reset-password';

export default ResetPassword;
